__turbopack_context__.v({
  "root": "_9MpHbW_root",
});
